import { ComponentChildren } from "preact";

import { ENV } from "../../foundation/constants";
import { EXEC_ENV } from "../../foundation/enums";

enum NATIVE_MENU_ERROR_TYPE {
    SUBMENU_CONTENT = "submenuContent",
    MENU_ITEM = "menuItem",
    UNSUPPORTED_CHILD = "unsupportedChild"
}

interface SubmenuContentError {
    type: NATIVE_MENU_ERROR_TYPE.SUBMENU_CONTENT;
    content: ComponentChildren;
}

interface MenuItemError {
    type: NATIVE_MENU_ERROR_TYPE.MENU_ITEM;
    child: ComponentChildren;
}

interface UnsupportedChildError {
    type: NATIVE_MENU_ERROR_TYPE.UNSUPPORTED_CHILD;
    child: ComponentChildren;
}

type NativeMenuError = SubmenuContentError | MenuItemError | UnsupportedChildError;

function addToNativeContextMenuErrorLogger(nativeMenuError: NativeMenuError, disabled: boolean) {
    if (ENV !== EXEC_ENV.local || disabled) {
        return;
    }

    if (nativeMenuError.type === NATIVE_MENU_ERROR_TYPE.SUBMENU_CONTENT) {
        throw new Error(
            `Your provided ContextMenu.SubMenu content:
            
            ${JSON.stringify(nativeMenuError.content)}
            
            ` +
            "is not a string. In order to show submenu in native context menu, it is mandatory to provide " +
            "content as string. If you want submenu to be shown in native context menu, please provide " +
            "'nativeMenuItems' prop as expected. You can provide 'allowNonNativeMenuItems' property to the " +
            "ContextMenu acknowledging it won't be shown in native applications"
        );
    }

    if (nativeMenuError.type === NATIVE_MENU_ERROR_TYPE.UNSUPPORTED_CHILD) {
        throw new Error(
            `Your provided child:
            
            ${JSON.stringify(nativeMenuError.child)}
            
            ` +
            "can not be converted to a native menu item. In order to have provided child in native context menu, " +
            "you should follow native menu guides. You can read about the rules in the component description on top " +
            "this file. If you want this child to be shown in native context menu, please provide 'nativeMenuItems' " +
            "prop as expected. You can provide 'allowNonNativeMenuItems' property to the ContextMenu acknowledging " +
            "it won't be shown in native applications"
        );
    }

    if (nativeMenuError.type === NATIVE_MENU_ERROR_TYPE.MENU_ITEM) {
        throw new Error(
            `Your provided ContextMenu.Item:
            
            ${JSON.stringify(nativeMenuError.child)}
            
            ` +
            "can not be converted to a native menu item. In order to have this item in native context menu, you " +
            "should follow native menu guides. You can read about the rules in the component description on top " +
            "this file. If you want this child to be shown in native context menu, please provide 'nativeMenuItems' " +
            "prop as expected. You can provide 'allowNonNativeMenuItems' property to the ContextMenu acknowledging " +
            "it won't be shown in native applications"
        );
    }
}

export { NATIVE_MENU_ERROR_TYPE, addToNativeContextMenuErrorLogger };
